import {
  getFirestore,
  collection,
  collectionGroup,
  where,
  onSnapshot,
  query,
  QueryConstraint,
  QuerySnapshot,
  DocumentData,
  Timestamp,
} from "firebase/firestore";
import { Leaderboard, LeaderboardBase } from "types";
import http from "axiosSetup";
import { firebaseApp } from "config/firebase";

class LeaderboardService {
  static subscribe(
    userId: string,
    leaderboard: Leaderboard,
    startDate: string,
    endDate: string,
    onNext: (snapshot: QuerySnapshot<DocumentData>) => void
  ) {
    const db = getFirestore(firebaseApp);

    if (leaderboard.measureType === "Score") {
      // Score-specific subscription using collectionGroup query
      const q = query(
        collectionGroup(db, "hyrox"),
        where("organisationId", "==", userId),
        where("createdAt", ">=", Timestamp.fromDate(new Date(startDate))),
        where("createdAt", "<=", Timestamp.fromDate(new Date(endDate)))
      );

      return onSnapshot(q, onNext);
    } else {
      // Existing exercise subscription logic
      const queryArgs: QueryConstraint[] = [];

      queryArgs.push(where("userId", "==", userId));
      queryArgs.push(where("exerciseId", "==", leaderboard.exerciseId));

      if (typeof startDate !== "undefined") {
        queryArgs.push(where("completedDate", ">=", new Date(startDate)));
      }

      if (typeof endDate !== "undefined") {
        queryArgs.push(where("completedDate", "<=", new Date(endDate)));
      }

      const q = query(collection(db, "measurement"), ...queryArgs);

      return onSnapshot(q, onNext);
    }
  }

  static async getAll() {
    const result = await http.get<Leaderboard[]>("/leaderboards").then((response) => response.data);
    return result.map(({ groups, groupIds, ...leaderboard }) => ({
      ...leaderboard,
      groups: undefined as unknown as any[],
      groupIds: groupIds || groups.map((group) => group.id),
    }));
  }

  // static getById(id: string) {
  //   return http.get<Leaderboard>(`/leaderboards/${id}`).then((response) => response.data);
  // }

  static create(leaderboard: LeaderboardBase) {
    return http
      .post<Leaderboard>("/leaderboards", {
        ...leaderboard,
        groups: undefined,
      })
      .then((response) => response.data);
  }

  static update(id: string, leaderboard: LeaderboardBase) {
    return http
      .put<Leaderboard>(`/leaderboards/${id}`, {
        ...leaderboard,
        groups: undefined,
      })
      .then((response) => response.data);
  }

  static delete(id: string) {
    return http.delete<{ id: string }>(`/leaderboards/${id}`).then((response) => response.data);
  }
}
export default LeaderboardService;
